exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".risolto-ag-grid{--ag-grid-size: 6px;--ag-row-hover-color: #f5f7fa}.risolto-ag-grid .ag-row--active{background-color:#e6f0ff !important}", ""]);

// exports
